import { type MCPServerInfo } from '../../types';

const DataHubServer: MCPServerInfo = {
  serverId: 'DATAHUB',
  name: 'DataHub',
  slug: 'datahub',
  description:
    'DataHub MCP server for searching and exploring your data catalog, lineage, ownership, and metadata. Supports both DataHub Cloud (Acryl) and self-hosted (open-source) instances.',
  source: {
    sourceType: 'REPOSITORY',
    type: 'OFFICIAL',
    repositoryUrl: 'https://github.com/acryldata/mcp-server-datahub',
    commitSha: 'latest',
    packageType: 'pip',
    packageName: 'mcp-server-datahub'
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['dataHubGmsUrl', 'dataHubAccessToken'],
    properties: {
      dataHubGmsUrl: {
        type: 'string',
        description:
          'DataHub GMS endpoint URL. For DataHub Cloud: https://<tenant>.acryl.io/gms. For self-hosted: e.g. https://datahub.yourcompany.com:8080 (the GMS service, typically on port 8080).',
        sensitive: false
      },
      dataHubAccessToken: {
        type: 'string',
        description:
          'DataHub personal access token. For agentic / unattended workflows, prefer a Service Account token. Create at Settings → Access Tokens in your DataHub instance.',
        sensitive: true
      }
    }
  }
};

export default DataHubServer;
